import React from "react";
import { Grid, Paper, Typography } from "@mui/material";
import BoxError from "../BoxError/BoxError";
import ImageUploadButton from "../FIleUploadButton/ImageUploadButton/ImageUploadButton";
import { BASE_IMG_URL } from "../../constants/mainAPI";

const PhotoUpload = (props: any) => {
    const [field, setField] = React.useState({
        photos: (props?.field?.photos || []).concat([{ photo: {} }]),
        delete_photos: (props?.field?.delete_photos || []).concat([]),
    });
    const handleOnChange = (e: any) => {
        let tmp = { ...field };
        if (e.target.name.search("delete_photos") === 0) {
            tmp.delete_photos = field.delete_photos.concat(e.target.value);
            let photoIndex = tmp.photos.findIndex((v: any) => v.id === e.target.value);
            if (photoIndex !== -1) tmp.photos[photoIndex] = null;
            e.target.name = "delete_photos";
            e.target.value = tmp.delete_photos;
        } else if (e.target.name.search("photos") === 0) {
            tmp.photos = field.photos.concat({ photo: {} });
            if (e.target.value === null) {
                tmp.photos[e.target.index] = null;
                delete tmp.photos[tmp.photos.length - 1];
            }
            e.target.name = "photos";
            e.target.value = tmp.photos;
        } else {
            // @ts-ignore
            tmp[e.target.name] = e.target.value;
        }
        setField(tmp);
        props.setValue("photos", tmp.photos);
        tmp.delete_photos.length !== 0 && props.setValue("delete_photos", tmp.delete_photos);
    };
    // @ts-ignore
    return (
        <Grid item xs={12}>
            <Paper
                variant="outlined"
                sx={{
                    borderColor: props.formError ? "#d32f2f" : "#A7A7A7",
                    height: "200px",
                    backgroundColor: "transparent",
                }}>
                <Typography>Изображения</Typography>
                <Typography sx={{ fontSize: "10px" }}>(png, jpeg)</Typography>
                <Grid container sx={{ height: "83%" }}>
                    {field.photos.map((item: any, index: any) =>
                        !item ? null : (
                            <BoxError
                                error={props.error && props.error[index]}
                                // @ts-ignore
                                sx={{ height: "100%" }}
                                key={index}>
                                <ImageUploadButton
                                    onChange={(file: any) => {
                                        if (file === null && item.id > 0) {
                                            handleOnChange({
                                                target: {
                                                    name: `delete_photos[${item.id}]`,
                                                    value: item.id,
                                                    id: item.id,
                                                },
                                            });
                                            return;
                                        }
                                        const file_name = typeof file?.name == "string" ? file.name : "";
                                        const file_url = file_name ? URL.createObjectURL(file) : file;
                                        item.photo = { file: file_url, name: file_name };
                                        if (file === null) item.photo = null;
                                        handleOnChange({
                                            target: {
                                                name: `photos[${index}]`,
                                                value: file === null ? null : item.photo,
                                                index,
                                            },
                                        });
                                    }}
                                    value={item?.photo?.file || (item?.path && `${BASE_IMG_URL}/${item?.path}`) || ""}
                                    name={`photos[${index}]`}
                                />
                            </BoxError>
                        ),
                    )}
                </Grid>
            </Paper>
        </Grid>
    );
};

export default PhotoUpload;
